export default {
  header: 'Úložisko predvolieb',
};
